import React, { useState, useRef } from 'react';
import { useOutsideClick } from '@panel/commons';
import {
  ContainerDropdown,
  CollapsedDropdown,
  ElementBox,
  TextSelected,
  Chevron,
  OpenDropdown,
  ListItems
} from './styles';

const DropdownBranches = ({ width, height, device, selectOptions, branchSelected, setBranchSelected }) => {
  const [dropDownState, setDropDownState] = useState(false);
  const listRef = useRef(null);

  const onClose = () => {
    if (dropDownState) {
      setDropDownState(false);
    }
  };
  useOutsideClick(listRef, onClose);

  const limitedText = value => {
    if (!value) return '';
    if (value && value.length >= 37) {
      return `${value.split('', 37).join('')}...`;
    }
    return value;
  };

  return (
    <ContainerDropdown device={device} width='fit-content' data-panel='panel-estadisticas-reputation-dropdownBranchId'>
      <CollapsedDropdown
        width='fit-content'
        height={height || '34px'}
        device={device}
        onClick={e => {
          e.stopPropagation();
          setDropDownState(!dropDownState);
        }}
        data-panel='panel-estadisticas-reputation-dropdownBranchId-close'
      >
        <ElementBox device={device}>
          <TextSelected
            data-panel='panel-estadisticas-reputation-dropdownBranchId-branchSelected'
            title={(branchSelected && branchSelected.name) || (selectOptions && selectOptions[0].name)}
          >
            {limitedText(branchSelected && branchSelected.name) || limitedText(selectOptions && selectOptions[0].name)}
          </TextSelected>
        </ElementBox>
        <Chevron device={device} data-panel='panel-estadisticas-reputation-chevron' active={dropDownState} />
      </CollapsedDropdown>
      <OpenDropdown
        device={device}
        active={dropDownState}
        ref={listRef}
        width={width}
        data-panel='panel-estadisticas-reputation-dropdownBranchId-open'
      >
        {selectOptions &&
          selectOptions.map(option => {
            return (
              <div key={option.branchId}>
                <ListItems
                  data-panel={`panel-estadisticas-reputation-dropdownBranchId-${option.branchId}`}
                  onClick={() => {
                    if (branchSelected && branchSelected.name !== option.name) {
                      setBranchSelected(option);
                    }
                    setDropDownState(!dropDownState);
                  }}
                >
                  {option.name}
                </ListItems>
              </div>
            );
          })}
      </OpenDropdown>
    </ContainerDropdown>
  );
};

export default DropdownBranches;
